import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("advocate.shubhammakkar@gmail.com");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("admin_token", data.token);
      localStorage.setItem("admin_email", data.email);
      toast.success("Signed in");
      nav("/admin");
    } catch {
      toast.error("Invalid credentials");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="pt-[72px] min-h-screen flex items-center bg-gradient-to-br from-[#EFF6FF] via-white to-slate-50" data-testid="admin-login-page">
      <div className="max-w-md mx-auto w-full px-6 py-20">
        <div className="w-14 h-14 bg-gradient-to-br from-[#1D4ED8] to-[#0A2540] flex items-center justify-center rounded-xl shadow-lg mb-6">
          <Lock size={20} className="text-white" />
        </div>
        <div className="text-[10px] uppercase tracking-[0.22em] font-semibold text-[#1D4ED8] mb-2">
          Admin Access
        </div>
        <h1 className="font-serif text-4xl text-[#0A2540] mb-8 font-semibold">Chambers console.</h1>
        <form onSubmit={submit} className="space-y-5 card-elevated p-8">
          <div>
            <label className="text-xs text-slate-500 uppercase tracking-wider font-semibold">Email</label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mt-1 bg-white border border-slate-200 px-3.5 py-3 text-slate-800 focus:border-[#1D4ED8] focus:outline-none focus:ring-2 focus:ring-[#1D4ED8]/15 rounded-lg text-sm transition-all"
              data-testid="login-email"
            />
          </div>
          <div>
            <label className="text-xs text-slate-500 uppercase tracking-wider font-semibold">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full mt-1 bg-white border border-slate-200 px-3.5 py-3 text-slate-800 focus:border-[#1D4ED8] focus:outline-none focus:ring-2 focus:ring-[#1D4ED8]/15 rounded-lg text-sm transition-all"
              data-testid="login-password"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            className="w-full primary-btn justify-center disabled:opacity-50"
            data-testid="login-submit"
          >
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
